import { z } from 'zod/v4';

/**
 * ModeOption defines the possible modes for ModeSelector component
 */
export type ModeOption = z.infer<typeof modeOptionSchema>;
export const modeOptionSchema = z.enum(['value', 'percentage']);

/**
 * SortOption defines whether to sort in ascending/descending order or use the original sort order.
 */
export type SortOption = z.infer<typeof sortOptionSchema>;
export const sortOptionSchema = z.enum(['asc', 'desc', 'default', 'series-name-asc', 'series-name-desc']);

/**
 * TooltipMode defines the possible modes for the tooltip in the schema.
 * TODO: add back all mode when tooltip performance is improved further
 * See TimeseriesTooltip.tsx for more details.
 */
export type TooltipMode = z.infer<typeof tooltipModeSchema>;
export const tooltipModeSchema = z.enum(['single', 'nearby']);

/**
 * TooltipSort defines behavior for the order of series in the TimeSeriesChart tooltip.
 */
export type TooltipSort = z.infer<typeof tooltipSortSchema>;
export const tooltipSortSchema = z.enum(['None', 'Descending']);
